import { useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import CategoryPage from "./components/CategoryPage.js";
import EndUserSignIn from "./components/enduser/EndUserSignIn";
import EndUserSignUp from "./components/enduser/EndUserSignUp";
import Layout from "./components/Layout";
import LocationPage from "./components/LocationPage.js";
import MemberSignIn from "./components/member/MemberSignIn";
import MemberSignUp from "./components/member/MemberSignUp";
import ChannelPartnerSignUp from "./components/partner/ChannelPartnerSignUp";
import SubCategoryPage from "./components/SubCategoryPage.js";
import { AuthProvider } from "./context.js";
import { CurrencyProvider } from "./features/context/CurrencyContext.js";
import About from "./pages/About";
import Cart from "./pages/Cart";
import ChannelPartner from "./pages/ChannelPartner.js";
import Checkout from "./pages/Checkout";
import CompanyRefer from "./pages/CompanyRefer.js";
import Contact from "./pages/Contact";
import CustomerSpeak from "./pages/CustomerSpeak.js";
import EditorialPolicy from "./pages/EditorialPolicy.js";
import FaQ from "./pages/FaQ.js";
import FooterPartner from "./pages/FooterPartner.js";
import Forgotpassword from "./pages/Forgotpassword";
import Forum from "./pages/Forum.js";
import Home from "./pages/Home";
import Login from "./pages/Login";
import OrderHistory from "./pages/orderHistory.js";
import Orders from "./pages/Orders";
import PaymentPolicy from "./pages/PaymentPolicy.js";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ProductDetails from "./pages/ProductDetails";
import CategoryProductsPage from "./pages/ProductsPage";
import Profile from "./pages/Profile";
import ReferAndEarn from "./pages/ReferAndEarn.js";
import RefundPolicy from "./pages/RefundPolicy";
import Resetpassword from "./pages/Resetpassword";
import ShippingPolicy from "./pages/ShippingPolicy";
import Signup from "./pages/Signup";
import TermAndContions from "./pages/TermAndContions";
import VendorPolicy from "./pages/VendorPolicy.js";
import Wishlist from "./pages/Wishlist";
import { OpenRoutes } from "./routing/OpenRoutes";
import { PrivateRoutes } from "./routing/PrivateRoutes";
import Repayment from "./components/partner/Repayment.js";
import CorporateSignup from "./components/corporate/corporateSignup.js";
import DirectorSignUp from "./components/director/directorSignup.js";
import VendorSignup from "./components/vendor/vendorSignup.js";
import VendorProductDetails from "./pages/vendorProductDetails.js";
import FranchiseSignUp from "./components/franchise/franchiseSignup.js";
import RetailerOrder from "./pages/retailerOrder.js";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// ModalWrapper component to render modals with backdrop
const ModalWrapper = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const previousPath = location.state?.from || "/";

  const handleClose = () => {
    navigate(previousPath, { replace: true });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-white rounded-lg shadow-lg modal-90w p-4">
        {children({ onHide: handleClose })}
      </div>
    </div>
  );
};

// Special handling for ChannelPartnerSignIn redirect
const ChannelPartnerSignInRedirect = () => {
  useEffect(() => {
    window.location.href = "https://lifeonplus.in/dashboardPanel/partnerLogin";
  }, []);
  return null;
};

function App() {
  const currency = localStorage.getItem("currency");
  return (
    <AuthProvider>
      <CurrencyProvider>
        <BrowserRouter basename="/">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={currency ? <Home /> : <LocationPage />} />
              <Route
                path="/category/:categoryName"
                element={<CategoryPage />}
              />
              <Route
                path="/category/:categoryName/:subCategoryName"
                element={<CategoryPage />}
              />
              <Route
                path="/category/:categoryName/:subCategoryName/:subSubCategoryName"
                element={<CategoryPage />}
              />
              <Route
                path="/category/:categoryName/:subCategoryName/:subSubCategoryName/:subSubSubCategoryName"
                element={<CategoryPage />}
              />
              <Route
                path="/category/:categoryName/:subCategoryName/products"
                element={<SubCategoryPage />}
              />
              <Route
                path="/category/:categoryName/:subCategoryName/:subSubCategoryName/products"
                element={<SubCategoryPage />}
              />
              <Route
                path="/category/:categoryName/:subCategoryName/:subSubCategoryName/:subSubSubCategoryName/products"
                element={<SubCategoryPage />}
              />
              <Route path="about" element={<About />} />
              <Route path="contact" element={<Contact />} />
              <Route path="product-details/:id" element={<ProductDetails />} />
              <Route
                path="vendor-product-details/:id"
                element={<VendorProductDetails />}
              />
              <Route path="cart" element={<Cart />} />
              <Route path="order-history" element={<OrderHistory />} />
              <Route path="categories/:id" element={<CategoryProductsPage />} />
              <Route path="profile" element={<Profile />} />
              <Route
                path="my-orders"
                element={
                  <PrivateRoutes>
                    <Orders />
                  </PrivateRoutes>
                }
              />
              <Route
                path="checkout"
                element={
                  <PrivateRoutes>
                    <Checkout />
                  </PrivateRoutes>
                }
              />
              <Route
                path="wishlist"
                element={
                  <PrivateRoutes>
                    <Wishlist />
                  </PrivateRoutes>
                }
              />
              <Route path="forgot-password" element={<Forgotpassword />} />
              <Route path="reset-password/:token" element={<Resetpassword />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="fees-and-payment" element={<PaymentPolicy />} />
              <Route path="refund-policy" element={<RefundPolicy />} />
              <Route path="shipping-policy" element={<ShippingPolicy />} />
              <Route path="term-conditions" element={<TermAndContions />} />
              <Route path="editorial-policy" element={<EditorialPolicy />} />
              <Route path="vendor-policy" element={<VendorPolicy />} />
              <Route path="partner-model" element={<FooterPartner />} />
              <Route path="company-refer" element={<CompanyRefer />} />
              <Route path="channel-partner" element={<ChannelPartner />} />
              <Route path="faq" element={<FaQ />} />
              <Route path="what-do-customer-say" element={<CustomerSpeak />} />
              <Route path="forum" element={<Forum />} />
              <Route path="repayment/:id" element={<Repayment />} />
              <Route path="refer" element={<ReferAndEarn />} />
              {/* Sign-in routes */}
              <Route
                path="signin/member"
                element={
                  <OpenRoutes>
                    <ModalWrapper>
                      {({ onHide }) => (
                        <MemberSignIn
                          show={true}
                          onHide={onHide}
                          // setIsAuthenticated={(val) =>
                          //   localStorage.setItem(
                          //     "user_website",
                          //     JSON.stringify({ data: { isAuthenticated: val } })
                          //   )
                          // }
                        />
                      )}
                    </ModalWrapper>
                  </OpenRoutes>
                }
              />
              <Route
                path="signin/enduser"
                element={
                  <OpenRoutes>
                    <ModalWrapper>
                      {({ onHide }) => (
                        <EndUserSignIn
                          show={true}
                          onHide={onHide}
                          // setIsAuthenticated={(val) =>
                          //   localStorage.setItem(
                          //     "user_website",
                          //     JSON.stringify({ data: { isAuthenticated: val } })
                          //   )
                          // }
                        />
                      )}
                    </ModalWrapper>
                  </OpenRoutes>
                }
              />
              <Route
                path="signin/channelpartner"
                element={
                  <OpenRoutes>
                    <ChannelPartnerSignInRedirect />
                  </OpenRoutes>
                }
              />
              {/* Sign-up routes */}
              <Route
                path="signup/member"
                element={
                  <OpenRoutes>
                    <ModalWrapper>
                      {({ onHide }) => (
                        <MemberSignUp show={true} onHide={onHide} />
                      )}
                    </ModalWrapper>
                  </OpenRoutes>
                }
              />
              <Route
                path="signup/enduser"
                element={
                  <OpenRoutes>
                    <ModalWrapper>
                      {({ onHide }) => (
                        <EndUserSignUp show={true} onHide={onHide} />
                      )}
                    </ModalWrapper>
                  </OpenRoutes>
                }
              />
              <Route
                path="signup/corporate"
                element={
                  <OpenRoutes>
                    <ModalWrapper>
                      {({ onHide }) => (
                        <CorporateSignup show={true} onHide={onHide} />
                      )}
                    </ModalWrapper>
                  </OpenRoutes>
                }
              />
              <Route
                path="signup/director"
                element={
                  <OpenRoutes>
                    <ModalWrapper>
                      {({ onHide }) => (
                        <DirectorSignUp show={true} onHide={onHide} />
                      )}
                    </ModalWrapper>
                  </OpenRoutes>
                }
              />
              <Route
                path="signup/channelpartner"
                element={
                  <OpenRoutes>
                    <ModalWrapper>
                      {({ onHide }) => (
                        <ChannelPartnerSignUp show={true} onHide={onHide} />
                      )}
                    </ModalWrapper>
                  </OpenRoutes>
                }
              />
              <Route
                path="signup/channelpartnerplus"
                element={
                  <OpenRoutes>
                    <ModalWrapper>
                      {({ onHide }) => (
                        <ChannelPartnerSignUp show={true} onHide={onHide} />
                      )}
                    </ModalWrapper>
                  </OpenRoutes>
                }
              />
              <Route
                path="signup/vendor"
                element={
                  <OpenRoutes>
                    <ModalWrapper>
                      {({ onHide }) => (
                        <VendorSignup show={true} onHide={onHide} />
                      )}
                    </ModalWrapper>
                  </OpenRoutes>
                }
              />
              <Route
                path="signup/franchise"
                element={
                  <OpenRoutes>
                    <ModalWrapper>
                      {({ onHide }) => (
                        <FranchiseSignUp show={true} onHide={onHide} />
                      )}
                    </ModalWrapper>
                  </OpenRoutes>
                }
              />
            </Route>
            <Route
              path="login"
              element={
                <OpenRoutes>
                  <Login />
                </OpenRoutes>
              }
            />
            <Route
              path="signup"
              element={
                <OpenRoutes>
                  <Signup />
                </OpenRoutes>
              }
            />
            <Route path="retailer/:id" element={<RetailerOrder />} />
          </Routes>
        </BrowserRouter>
      </CurrencyProvider>
    </AuthProvider>
  );
}

export default App;
